import { Component, OnInit, Input, Output, OnDestroy } from "@angular/core";
import { AngularFireDatabase } from "@angular/fire/database";
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from "@angular/fire/firestore";
import { takeUntil } from "rxjs/operators";
import { UserManager } from "../../Services/UserManager/user-manager";
import {
  trigger,
  state,
  transition,
  animate,
  style,
} from "@angular/animations";
import { ConversationMeta } from "../../Models/conversation.interface";
import { EventEmitter } from "@angular/core";
import { Profile } from "../../Models/profile.interface";
import { Subscription, Subject } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { MySchoolAddInstructorComponent } from "src/app/my-school/my-school-add-instructor/my-school-add-instructor.component";
import "firebase/firestore";
import _ from "lodash";
import { PROFILES } from "src/Constants";

@Component({
  selector: "app-my-school-contacts",
  templateUrl: "./my-school-contacts.component.html",
  styleUrls: [
    "./my-school-contacts.component.css",
    "../../components/volunteer/volunteer.component.scss",
  ],
  animations: [
    trigger("trigger", [
      state("void", style({ opacity: 0 })),
      state("show", style({ opacity: 1 })),
      transition("void => *", [animate("300ms ease-in-out")]),
      transition("* => void", [animate("300ms ease-in-out")]),
    ]),
    trigger("chooseLimitTrigger", [
      state(
        "void",
        style({ opacity: 0, width: 0, transform: "translateY(-10px)" })
      ),
      state(
        "show",
        style({ opacity: 1, width: "*", transform: "translateY(0)" })
      ),
      transition("void => *", [animate("100ms ease-in-out")]),
      transition("* => void", [animate("100ms ease-in-out")]),
    ]),
    trigger("auto", [
      state(
        "void",
        style({ opacity: 0, height: 0, transform: "translateX(-10px)" })
      ),
      state(
        "show",
        style({ opacity: 1, width: "*", transform: "translateX(0)" })
      ),
      transition("void => *", [animate("100ms ease-in-out")]),
      transition("* => void", [animate("100ms ease-in-out")]),
    ]),
    trigger("item", [
      transition(":enter", [
        style({ height: 0, transform: "scale(0)", opacity: 0 }),
        animate(
          "300ms",
          style({ height: "*", transform: "scale(1)", opacity: 1 })
        ),
      ]),
      transition(":leave", [
        style({ height: "*", transform: "scale(1)", opacity: 1 }),
        animate(
          "100ms",
          style({ height: 0, transform: "scale(0)", opacity: 0 })
        ),
      ]),
    ]),
  ],
})
export class MySchoolContactsComponent {
  @Input() firstname: string;
  @Input() lastname: string;
  @Input() uid: string;
  @Input() orgId: string;
  @Input() entityId: string;
  @Input() reload: string;
  @Input() orgName: string;
  @Input() authLevel: string;
  @Output() choice = new EventEmitter<ConversationMeta>();
  invitations = [];
  profileSubject;
  profile: Profile;
  currentState = "void";
  limitTrigger = "void";
  autoReplyTrigger = "void";
  autoReplyBody = "";
  autoReplies = [];
  conversations;
  filterFunction;

  ascending: OrderByDirection = "desc"; // 'asc'
  pages: Array<any>;
  total;
  filter;
  order;
  _order;
  needsReset;
  hasNextPage: boolean;
  hasLastPage: boolean;
  conversationsRef: AngularFirestoreCollection<ConversationMeta>;
  unclaimed;
  instructorToFind: string;
  unreadMessages;
  showSystem = false;
  sub: Subscription;
  leaving = new Subject<null>();
  instructors = {};
  profiles = {};

  constructor(
    public dialog: MatDialog,
    private db: AngularFireDatabase,
    private afs: AngularFirestore
  ) {}

  openDialog(): void {
    const dialogRef = this.dialog.open(MySchoolAddInstructorComponent, {
      width: "250px",
      data: { email: "", emails: [] },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (_.isArray(result)) {
        this.invitations = result;
      } else if (_.isString(result)) {
        this.invitations = [result];
      } else {
        // present the error
      }
      this.invitations && this.sendInvitations();
    });
  }

  sendInvitations = () => {
    //exclude instructors that are already invited

    //exclude already invited individuals
    this.afs
      .collection<Profile>(PROFILES, (ref) =>
        ref.where("entityId", "==", this.entityId)
      )
      .valueChanges()
      .take(1)
      .subscribe((exclusions) => {
        //@ts-ignore
        exclusions = _.map(exclusions, (x) => x.email) as string[];
        const invites = _.difference(this.invitations, exclusions);

        _.forEach(invites, (email) => {
          this.db.list(`StudentInvitations/${this.orgId}`).push({
            sender: this.firstname + " " + this.lastname,
            org: this.orgName,
            entityId: this.entityId,
            email,
          });
        });
      });
  };
}
// because i can't find where to import this...
type OrderByDirection = "desc" | "asc";
